import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filter'
})
export class FilterPipe implements PipeTransform {

  transform(value: any[], args?: string): any[] {
    if (!args || !value) return value;

    const filterValue = args.toLowerCase();

    return value.filter(el => {
      return (
        (el.sDesLargo01?.toLowerCase().includes(filterValue)) || // Zona
        (el.sDesLargo03?.toLowerCase().includes(filterValue))    // Dirección
      );
    });
  }
}
